import React, { useEffect, useState } from 'react';
import { UserButton } from '@clerk/clerk-react';
import LevelCircle from './LevelCircle';

// this component displays the user's level and a user button
function LevelAndUserButton() {
  const [userStats, setUserStats] = useState(null);
  const [userTheme, setUserTheme] = useState('#1976d2'); // default color

  useEffect(() => {
    const fetchUserStats = async () => {
      const clerkUserId = localStorage.getItem('userId');
      if (clerkUserId) {
        try {
          const response = await fetch('/server/crazy-cup-server/getUserStats.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ clerk_user_id: clerkUserId }),
          });

          const result = await response.json();
          if (result.success) {
            setUserStats(result.stats);
          } else {
            console.error('Error fetching user stats:', result.message);
          }
        } catch (error) {
          console.error('Error connecting to the server:', error);
        }

        // Fetch user theme color
        try {
          const settingsRes = await fetch('/server/crazy-cup-server/getUserSettings.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId: clerkUserId }),
          });
          const settingsData = await settingsRes.json();
          if (settingsData.success && settingsData.settings && settingsData.settings.theme) {
            setUserTheme(settingsData.settings.theme);
          }
        } catch (error) {
          console.error('Error fetching user theme:', error);
        }
      }
    };

    fetchUserStats();
  }, []);

  return (
    <div className="level-and-userbutton">
      {/* LevelCircle on the top-left */}
      {userStats && (
        <LevelCircle
          level={userStats.level}
          xp={userStats.xp}
          xpToNextLevel={userStats.xp_to_next_level}
          className="top-level-circle"
        />
      )}

      {/* UserButton on the top-right */}
      <div
        className="user-button-outline"
        style={{
          backgroundColor: userTheme
        }}
      >
        <UserButton
          className="user-button"
          appearance={{
            elements: {
              userButtonAvatarBox: {
                width: '70px',
                height: '70px',
              },
            },
          }}
        />
      </div>
    </div>
  );
}

export default LevelAndUserButton;